// src/pages/user/MyRewards.js — Codes promo gagnés par le client (v1.65.0)
// Maxula
import React, { useEffect, useState, useCallback } from 'react';
import { FiGift, FiCopy, FiRefreshCw } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { rewardAPI } from '../../services/api';

const STATE_LABEL = {
  active: { txt: 'Disponible', cls: 'bg-green-100 text-green-700' },
  used: { txt: 'Utilisé', cls: 'bg-gray-200 text-gray-600' },
  expired: { txt: 'Expiré', cls: 'bg-red-100 text-red-700' },
  inactive: { txt: 'Inactif', cls: 'bg-gray-200 text-gray-600' }
};

export default function MyRewards() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await rewardAPI.mine(); setRows(Array.isArray(data?.data) ? data.data : []); }
    catch (e) { setRows([]); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const copy = (code) => { navigator.clipboard?.writeText(code); toast.success('Code copié — appliquez-le dans votre panier'); };

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold flex items-center gap-2"><FiGift className="text-[#0ea5e9]" /> Mes récompenses</h2>
        <button onClick={load} className="p-2 border rounded-lg hover:bg-gray-50"><FiRefreshCw size={16} /></button>
      </div>
      <p className="text-sm text-gray-500 mb-5">Les codes promo gagnés grâce à vos achats. À appliquer dans le panier lors d'une prochaine commande.</p>

      {loading ? (
        <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#0ea5e9]" /></div>
      ) : rows.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm p-10 text-center text-gray-500">
          Vous n'avez pas encore de récompense. Effectuez un achat pour en gagner ! 🎁
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {rows.map((r) => {
            const color = r.color || '#0ea5e9';
            const val = r.type === 'percentage' ? `-${r.value}%` : `-${r.value} DH`;
            const st = STATE_LABEL[r.state] || STATE_LABEL.active;
            const expire = r.expiresAt ? new Date(r.expiresAt).toLocaleDateString('fr-FR') : null;
            const usable = r.state === 'active';
            return (
              <div key={r.code} className="space-y-2">
                <div className="relative overflow-hidden rounded-2xl text-white shadow-lg" style={{ background: `linear-gradient(135deg, ${color}, ${color}cc)`, opacity: usable ? 1 : 0.6 }}>
                  <div className="absolute -left-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white/90" />
                  <div className="absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-white/90" />
                  <div className="p-5">
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-semibold uppercase tracking-wider opacity-90">Récompense Maxula</span>
                      <FiGift />
                    </div>
                    <div className="mt-3 flex items-end gap-2">
                      <span className="text-4xl font-extrabold leading-none">{val}</span>
                      <span className="opacity-90 text-sm mb-1">offerts</span>
                    </div>
                    <div className="mt-4 border-2 border-dashed border-white/60 rounded-lg px-3 py-2 text-center font-mono font-bold tracking-widest text-lg">{r.code}</div>
                    <div className="mt-3 flex items-center justify-between text-[11px] opacity-90">
                      <span>{Number(r.minPurchase) > 0 ? `Dès ${r.minPurchase} DH d'achat` : 'Sans minimum'}</span>
                      <span>{expire ? `Exp. ${expire}` : 'Sans expiration'}</span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-between px-1">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${st.cls}`}>{st.txt}</span>
                  <button onClick={() => copy(r.code)} disabled={!usable} className="flex items-center gap-1 px-3 py-1.5 border rounded-lg text-xs hover:bg-gray-50 disabled:opacity-50"><FiCopy size={13} /> Copier</button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
